import { makeStyles } from "@material-ui/core";
import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles(() => ({
  slide: {
    margin: 15
  },
  img: {
    width: "100%",
    height: "auto"
  }
}));

export default function Slides() {
  const classes = useStyles();

  return (
    <AutoPlaySwipeableViews>
      {[1, 2, 3].map(item => (
        <div className={classes.slide} key={item}>
          <Skeleton variant="rect" width="100%" height="30vh" />
        </div>
      ))}
    </AutoPlaySwipeableViews>
  );
}
